import React from 'react';
import {Box, Typography, useTheme, useMediaQuery, Backdrop, Container, Stack} from '@mui/material';

import {NoAccessIcon} from '../../icons/Icons/NoAccessIcon';

export function NoAccessComponent({noAccessHeading, noAccessDesc}: {noAccessHeading: string; noAccessDesc: string}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Container sx={{p: isMobile ? 2 : 4}}>
      <Backdrop
        sx={{position: 'relative', bgcolor: 'secondary.dark', p: isMobile ? 4 : 8, borderRadius: isMobile ? 6 : 16}}
        open
      >
        <Stack
          sx={{
            maxWidth: 511,
            textAlign: isMobile ? 'left' : 'center',
            alignItems: isMobile ? 'flex-start' : 'center'
          }}
        >
          <Box sx={{mx: isMobile ? 'auto' : 0}} />
          <NoAccessIcon width={isMobile ? 191 : 404} height={isMobile ? 191 : 404} />
          <Typography variant={isMobile ? 'h2' : 'h1'}>{noAccessHeading}</Typography>
          <Typography variant="body1" color="text.onAccent" mt={1}>
            {noAccessDesc}
          </Typography>
        </Stack>
      </Backdrop>
    </Container>
  );
}
